import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
    WithStyles,
    createStyles,
    Typography,
    List,
    Divider,
    ListItem,
    ListItemText,
    Checkbox,
    Link,
    Button,
    FormControlLabel,
    Radio
} from '@material-ui/core';
import cx from 'classnames';
import DeleteIcon from '@material-ui/icons/Delete'
import { MyPATDialog, MyPATTextArea, MyPATTextField, MyPATSelect } from '../../common';
import { ContentSubType } from '../types/ContentSubTypeBody';
import { saveNewTestType, getTestTemplateType, deactiveTestType, showMsg,  } from '../actions/testTemplateActions';
import {testTemplateService} from '../services/testTemplateService';
import ACL from '../../acl/components/ACL';
import { praticeTestTypeCode, titleCase, TEMPLATE_SETTING_FILTER_TYPES, PERMISSION_CONTENT_TYPES, TEST_TEMPLATE_TYPES, USER_RIGHTS, MODULE_TO_TEST_MAP } from '../../../constants/comman';
import ACLService from '../../acl/services/aclService';
import { contentTypeList } from '../../mylibrary/actions/contentTypeActions';
import { setActiveTestType } from '../types/TypeOfTestTemplateAction';


const styles = (theme: Theme) => createStyles({
    root: {
        ...theme.mixins.gutters(),
        width: '100%',
        maxWidth: '100%',
    },
    activeSelected: {
        backgroundColor: theme.palette.primary.main + "!important",
        '& input': {
            color: theme.palette.common.black,
        },
        '& *': {
            color: theme.palette.common.white,
            marginBottom: 0,
        },
        '&::after': {
            border: "7px solid transparent",
            content: "''",
            position: "absolute",
            right: "-14px",
            borderLeftColor: theme.palette.primary.main//"#2E93FB"
        },
    },

    textCenter: {
        textAlign: "center"
    },
    cursorP: {
        cursor: "pointer"
    },
    colorBlack:{
        color:"black",
    },
    paddingZero: {
        padding: "0px"
    },
    primary: {
    },
    deleteI: {
        fontSize: 18,
        float: "right",
        display: "none",
        position: "absolute",
        right: "4px",
        top: "14px"
    },
    onHover: {
        '&:hover svg': {
            display: 'block'
        },
    },
    paddingSM: {
        padding: '6px 0px 10px'
    },
    svBtn: {
    padding: '0 16px',
    },

    svBtn2: {
        marginBottom: 6,
        height: 44,
        borderRadius: 0,
        padding: '0 16px',
    },
    disable: {
		opacity: 0.5,
		pointerEvents: "none"
	},
    templateTypeFilter: {
        padding: '20px 15px',
        display: "flex",
        flexDirection: "column",
        gap: '20px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    },
    catagoryDropdown: {
        display: "flex",
        flexDirection: "column",
        gap: '10px',
    },
    testTemplateType: {
        display: "flex",
        flexDirection: "column",
        gap: '10px',
    },
    filterDescriptor: {
        color: "#666",
        fontFamily: "Nunito",
        fontSize: '14px',
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "normal",
    },
    templateTypeCheckboxContainer: {
        display: 'flex',
        gap: '4px',
    },
});
interface TemplateTypesProps extends WithStyles<typeof styles> {
    testTemplateType: ContentSubType[];
    updateTestTemplateTypeList : Function;
    getTestTemplateType: (subType: string) => void;
    transferToParent: (activeTestType: string) => void;
    userData: any;
    selectedTestTypeFilter: string;
    testTypesAccess: any[];
    selectedTemplateTypeFilter: string;
    templateTypesAccess: any[];
    onFilterChanged: Function;
    contentTypeList: Function,
    contentType: any;
    setActiveTestType: Function
}

interface ContentFilterStates {
    addFilterOpen: boolean,
    testName: string,
    isAddNew: boolean,
    isPageLoad: boolean,
    deactivateTest: boolean,
    deactiveId: string,
    editTestTypeId:string,
}

class TemplateTypes extends Component<TemplateTypesProps, ContentFilterStates>{

    constructor(props: TemplateTypesProps) {
        super(props);

        this.state = {
            addFilterOpen: false,
            testName: "",
            isAddNew: false,
            isPageLoad: true,
            deactivateTest: false,
            deactiveId: "",
            editTestTypeId : "",
        };
        this.props.contentTypeList();

    }

    changeNewTemplateName = (event: any) => {
        this.setState({
            testName: event.target.value
        });
    }

    showEditNew = (id:any) => {
        this.setState(
            {
                editTestTypeId:id
            }
        );
    }

    hideEditNew = (e:any) => {
        let {editTestTypeId, testName} = this.state;
        // let newName = e.target.value;
        let newName = testName;

        if(!newName){
            return;
        }
        
        //api call
        testTemplateService.updateTestTemplateType(editTestTypeId, newName)
        .then((res)=>{
            // this.props.getTestTemplateType("testpapers")
            this.props.updateTestTemplateTypeList();
        })

        this.setState({
            editTestTypeId: "",
            testName: ""
        })
    }
    showAddNew = () => {
        this.setState({
            isAddNew: true,
        })
    }

    addTemplateList = (event: any) => {
        const {selectedTemplateTypeFilter, selectedTestTypeFilter, contentType} = this.props
        if (this.state.testName != "") {
            let contentTypeId = ""
            let templateLength = 0;
            if (this.props.testTemplateType && this.props.testTemplateType.length > 0) {
                templateLength = this.props.testTemplateType.length + 1;
            }
            const content = (contentType.list || []).find((type: any) => type.code === MODULE_TO_TEST_MAP[selectedTestTypeFilter]) || {};
            contentTypeId = content._id || '';
            let reqTest: any = {
                _id: "",
                name: this.state.testName,
                code: 'full',
                isActive: true,
                contentTypeId: contentTypeId,
                order: templateLength,
                templateType: selectedTemplateTypeFilter,
                contentType: MODULE_TO_TEST_MAP[selectedTestTypeFilter]
            }
            saveNewTestType(reqTest)
                .then((res: any) => {
                    if (res) {
                        this.props.updateTestTemplateTypeList('newTestType', res._id);
                    }
                })
            this.setState({
                testName: "",
                isAddNew: false
            });
        }
    }

    selectTestType(this: any, id: any) {
        let a: ContentSubType[] = this.props.testTemplateType;
        a.map((o) => {
            if (o._id == id){
                o.isSelected = true;
                this.props.changeCurrentTemplateType(o.code, id);
                this.props.setActiveTestType(o);
            }
            else
            {
                o.isSelected = false;
            }
            return o;
        });

        //transfer id to parent 
        this.props.transferToParent(id);
    }


    deactivateTestType(e: any, id: string) {
        this.setState({
            deactivateTest: !this.state.deactivateTest,
            deactiveId: id
        });
        e.stopPropagation();
    }

    confirmDeactivate(e: any) {
        deactiveTestType(this.state.deactiveId)
            .then((res) => {
                this.setState({
                    deactivateTest: !this.state.deactivateTest,
                    deactiveId: ""
                });
                if (res.status) {
                    //If added pass id and show data
                    this.props.updateTestTemplateTypeList();
                    showMsg(res.msg, 'success');
                } else {
                    showMsg(res.msg, 'error');
                }
            })
    }

    changeSelectedTestTemplate(templateType: any): void {
        this.props.onFilterChanged(templateType, TEMPLATE_SETTING_FILTER_TYPES.TEMPLATE_TYPE);
        this.setState({ isAddNew: false })
    }

    render() {
        const { classes } = this.props;
        let { testTemplateType, templateTypesAccess, testTypesAccess, selectedTemplateTypeFilter, onFilterChanged, selectedTestTypeFilter } = this.props;
        testTemplateType = (testTemplateType || []).filter((element: any)=> element.code != praticeTestTypeCode);
        const { testName, isAddNew, deactivateTest, deactiveId,editTestTypeId } = this.state;
        return (
            <>
                <List className={cx(classes.paddingZero)}>
                    <div className={classes.templateTypeFilter}>
                        <div className={classes.catagoryDropdown}>
                            <span className={classes.filterDescriptor}>Select Test Category</span>
                            <MyPATSelect
                                label=""
                                value={selectedTestTypeFilter}
                                onChange={(event: any) => { onFilterChanged(event.target.value, TEMPLATE_SETTING_FILTER_TYPES.TEST_TYPE) }}
                                disabled={false}
                            >
                                {
                                    _.map(testTypesAccess, (option, optionIndex) => {
                                        return (
                                            <option key={option.value} value={option.value} >{option.title}</option>
                                        )
                                    })
                                }
                            </MyPATSelect>
                        </div>
                        {(templateTypesAccess.length > 1) &&
                            (<div className={classes.testTemplateType}>
                                <span className={classes.filterDescriptor}>Select Test Type</span>
                                <div className={classes.templateTypeCheckboxContainer}>
                                    {templateTypesAccess.map(templateType =>
                                    (<FormControlLabel
                                        style={{ height: "24px" }}
                                        control={<Radio checked={templateType === selectedTemplateTypeFilter} color="primary" />}
                                        label={titleCase(templateType)}
                                        onChange={() => {this.changeSelectedTestTemplate(templateType)}}
                                        key={templateType}
                                        value={templateType}
                                    />)
                                    )}
                                </div>
                            </div>)
                        }
                    </div>
                
                    {   
                        
                        _.map(testTemplateType, (filterData, i) => {
                            return (
                                <ListItem
                                    key={`${_.get(filterData,'_id')} ${i}`}
                                    selected={filterData.isSelected ? filterData.isSelected : false}
                                    onClick={this.selectTestType.bind(this, filterData._id)}
                                    className={cx(filterData.isSelected ? classes.activeSelected : "", classes.onHover)}
                                    divider={true}
                                    onDoubleClick={() => this.showEditNew(filterData._id)}
                                    button

                                >


                                    {
                                        !_.isEqual(editTestTypeId, filterData._id) &&
                                        <ListItemText
                                            id={"list_" + filterData._id}
                                            classes={{ primary: classes.primary }}
                                            primaryTypographyProps={{ variant: 'body1' }}
                                        >
                                            {filterData.name}
                                        </ListItemText>
                                    }
                                    {
                                     _.isEqual(editTestTypeId, filterData._id) &&
                                        <ListItem
                                            key={testTemplateType.length + 1}
                                        >
                                            <MyPATTextField
                                                inputId="newTestType"
                                                name="newTestType"
                                                defaultValue={filterData.name}
                                                onChange={this.changeNewTemplateName.bind(this)}
                                                placeholder="Enter Test Type"
                                                fullWidthControl
                                            >
                                                
                                            </MyPATTextField>
                                            <span><Button onClick={this.hideEditNew.bind(this)}
                                             variant="contained"
                                             color="primary"
                                             className={classes.svBtn}>
                                                 Save</Button></span>
                                        </ListItem>
                                    }

                                        <DeleteIcon onClick={(e: any) => { this.deactivateTestType(e, filterData._id) }} className={`${classes.deleteI} ${!ACLService.checkModulePermission(selectedTemplateTypeFilter === TEST_TEMPLATE_TYPES.DEFAULT ? PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE : PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE, USER_RIGHTS.EDIT) ? classes.disable : ""}`} />
                                </ListItem>
                            );
                        })
                    }
                    {
                        (isAddNew)
                            ?
                            <ListItem
                                key={testTemplateType.length + 1}
                            >
                                <MyPATTextArea
                                    inputId="newTestType"
                                    name="newTestType"
                                    value={testName}
                                    onChange={this.changeNewTemplateName.bind(this)}
                                    placeholder="Enter Test Type"
                                    fullWidthControl
                                >
                                </MyPATTextArea>
                                <span><Button onClick={this.addTemplateList.bind(this)}
                                variant="contained"
                                color="primary"
                                 className={classes.svBtn2}>
                                     Save</Button></span>
                            </ListItem>
                            : ""
                    }

                </List>

                {ACLService.checkModulePermission(selectedTemplateTypeFilter === TEST_TEMPLATE_TYPES.CUSTOM ? PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE : PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE, USER_RIGHTS.CREATE) &&
                    <div className={cx(classes.textCenter, classes.cursorP, classes.paddingSM)}>
                        <Link
                            onClick={this.showAddNew.bind(this)}
                            variant="body2"
                            underline="none"
                        >
                            Add New {titleCase(selectedTemplateTypeFilter)} Test Type
                        </Link>
                    </div>}
                <MyPATDialog
                    dialogOpen={deactivateTest}
                    otherDialogProps={{
                        fullWidth: true,
                        maxWidth: 'sm',
                    }}
                    customDialogActions={
                        <>
                                <Button onClick={() => { this.confirmDeactivate(this) }} color="primary">Delete</Button>
                                <Button
                                    variant="contained" color="primary"
                                    onClick={(e) => { this.deactivateTestType(e, deactiveId) }}>
                                    Cancel
                            </Button>
                        </>
                    }
                >
                    <Typography variant="body1">
                        <strong>Are you sure you want to delete permanently?</strong>
                    </Typography>
                </MyPATDialog>


            </>
        );
    }
}
const mapStateToProps = (state: any) => ({
    // map state to props here
    userData: state.loginData.userData,
    contentType: _.get(state, 'mylibraryData.contentType', {}),

}
);

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
        getTestTemplateType,
        contentTypeList,
        setActiveTestType
    },
    dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TemplateTypes));